// export const base_url = 'http://localhost:8000';

// Function to dynamically generate base URL
export const getBaseUrl = (): string => {
  const hostname = window.location.hostname;

  console.log("Current Hostname:", hostname);

  // Custom backend mapping
  if (hostname.endsWith('testplan.harman.com') !== true) {
      //const url = 'https://be.testplan.harman.com';

      const url = "https://web.harman.service.staging.247uptime.io/";
      //const url = "http://localhost:8000";

      console.log("Matched testplan domain");
      console.log("Generated Base URL:", url);

      return url;
  }

  // Default URL
  const defaultUrl = `https://${hostname}`;

  console.log("Default Base URL:", defaultUrl);

  return defaultUrl;
};

// Final API base URL
export const base_url = `${getBaseUrl().replace(/\/$/, '')}/api/v1`;

console.log("Final API URL:", base_url);

// Namespace
export const namespace = "247fn://harman.com";

console.log("Namespace:", namespace);